import {action, observable, runInAction} from "mobx";
import service from "../services";

export default class CrifStore {
    rootStore;

    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    @observable logsList = {};

    @action getLogs = async (criteria) => {
        try {
            const logs = await service.Crif.getLogs(criteria);
            runInAction("getting logs", () => {
                this.logsList = logs;

                return true;
            });
        } catch (error) {
            runInAction("getting logs error", () => {
                this.logsList = [];

                return false;
            });
        }
    };

    @action newLogCriteria = () => {
        let dateFrom = new Date((new Date()).setDate((new Date()).getDate() - 15));
        let dateTo = new Date((new Date()).setDate((new Date()).getDate() + 1));
        let fixedDateFrom = new Date(dateFrom.getFullYear(), dateFrom.getMonth(), dateFrom.getDate());
        let fixedDateTo = new Date(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate());

        let isoStartTime = new Date(fixedDateFrom.getTime() - (fixedDateFrom.getTimezoneOffset() * 60000)).toISOString();
        let isoEndTime = new Date(fixedDateTo.getTime() - (fixedDateTo.getTimezoneOffset() * 60000)).toISOString();

        return {
            startDate: fixedDateFrom,
            startDateISO: isoStartTime,
            endDate: fixedDateTo,
            endDateISO: isoEndTime,
            userId: null,
            crifRequestType: null,
            crifReportType: null,
            page: 1,
            isTest: false
        }
    };
}